import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import WorkerStatus from "./WorkerStatus";

export default class UpdateWorkerStatusRequest extends BaseUpdateRequest {
    status: WorkerStatus;
}